import { jsx } from "react/jsx-runtime";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { validateTidalLicense } from "../../base/index.js";
function VisibilityOff(props) {
  return /* @__PURE__ */ jsx(
    VisibilityOffIcon,
    {
      "data-testid": "VisibilityOff",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "VisibilityOff",
      "data-tidal-icon-meta": "map,location,time"
    }
  );
}
VisibilityOff.tidalIconMeta = {
  categories: "map,location,time",
  name: "VisibilityOff"
};
validateTidalLicense();
export {
  VisibilityOff
};
//# sourceMappingURL=VisibilityOff.js.map
